export default __webpack_public_path__ + "ddca9ed75f8abb75ed05d7539ef0762d.png";